import PropTypes from "prop-types";

import styled, { css } from "styled-components";
import { BREAKPOINTS } from "@onelogin/react-components";
import { WIDE_VIEW_LIMIT } from "../constants/Env";

const ResponsiveBlock = styled.div`
  margin: auto;
  width: ${BREAKPOINTS.WIDE_VIEW_LIMIT};
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: ${props => props.maxHeight && `100%`};
  align-items: ${props => props.centered && `center`};
  min-height: ${props => props.fillHeight && "100%"};

  ${props =>
    props.noPaddings !== true &&
    css`
      padding: 0 32px;
    `};

  @media screen and (max-width: ${WIDE_VIEW_LIMIT + 2 * 32}px) {
    width: calc(100% - 2 * 32px);
    ${props =>
      props.noPaddings !== true &&
      css`
        padding: 0 32px;
      `};
  }

  @media screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}) {
    flex-direction: column;
    width: calc(100% - 2 * 32px);
  }

  @media screen and (max-width: ${BREAKPOINTS.PHONE_LARGE}) {
    padding: 0;
    width: 100%;
  }
`;

ResponsiveBlock.propTypes = {
  noPaddings: PropTypes.bool,
  fillHeight: PropTypes.bool,
  centered: PropTypes.bool
};

export default ResponsiveBlock;
